import React, { useState, useRef, useEffect } from 'react';
import styles from './Tooltip.module.scss'; // Подключение стилей для Tooltip

type TooltipProps = {
    text: string;
};

const HIDING_DELAY_MS = 500;

const Tooltip: React.FC<TooltipProps> = ({ text }) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const timeoutId = useRef<NodeJS.Timeout | undefined>(undefined);
    const tooltipRef = useRef<HTMLDivElement>(null);

    const showTooltip = () => {
        if (timeoutId) clearTimeout(timeoutId.current);
        setIsVisible(true);
    };

    const hideTooltip = () => {
        const id = setTimeout(() => {
            setIsVisible(false);
        }, HIDING_DELAY_MS);
        timeoutId.current = id;
    };

    const cancelHideTooltip = () => {
        if (timeoutId) clearTimeout(timeoutId.current);
    };

    useEffect(() => {
        return () => {
            if (timeoutId) clearTimeout(timeoutId.current);
        };
    }, []);

    return (
        <div
            className={styles['tooltip-container']}
            ref={tooltipRef}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
        >
            {isVisible && (
                <div
                    className={styles['tooltip-box']}
                    onMouseEnter={cancelHideTooltip}
                    onMouseLeave={hideTooltip}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            )}
        </div>
    );
};

export default Tooltip;
